import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './topbar.css'

const data1 = [
    { name: 'Publication', link: '/cis_publication' },
    { name: 'Research Division', link: '/report' },
    { name: 'Research Clusters', link: '/research/cluster' },
    { name: 'CIS Faculty', link: '/research/faculty' },
    { name: 'CIS Student Theses', link: '/theses' },
]
const data2 = [
    { name: 'Islamic Economics & Finance', link: '/economics' },
    { name: 'Islamic Bioethics Project', link: '/bioethics' },
    { name: 'Covenants of the Prophet Muhammed', link: '/convenants' },
    { name: 'The Digital Sira Initiative', link: '/sira' }
]
const data3 = [
    { name: 'Biographies', link: '/biographies' },
    { name: 'Glossary of Terms', link: '/glossary' },
    { name: 'Islamic Finance Periodicals', link: '/periodicals/English/0' },
    { name: 'Financial Institutions in Qatar', link: '/financial_institution' },
    { name: 'Academic Institutions', link: '/academic_institution/page/0' },
]
const data4 = [
    { name: 'Research Strategy', link: '/biographies' },
    { name: 'Research Division', link: '/glossary' },
    { name: 'Research Cluster', link: '/periodicals/English/0' },
    { name: 'CIS Faculty', link: '/financial_institution' },
]







class TopBar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: []
        }
    }

    componentDidMount = () => {
        if (this.props.data == 'data2')
            this.setState({
                data: data2
            })
        else if (this.props.data == 'data1')
            this.setState({
                data: data1
            })
        else if (this.props.data == 'data3')
            this.setState({
                data: data3
            })
        else
            this.setState({
                data: data4
            })
    }

    render() {
        return (
            <div className='top-bar'>
                <div className='bar-item'>
                    {this.state.data.map((data) => {
                        return <Link style={{ color: data.link == window.location.pathname ? '#165E84' : '' }} to={data.link}>{data.name}</Link>

                    })}
                </div>
            </div>
        )
    }
}
export default TopBar;